export const getters = {
    getFundList: state => state.fundList,
    getTrendingFundList: state => state.fundTrendingList,
    getTrendingFundTopThreeList: state => state.fundTrendingList.filter((_, index) => {
        return index < 3
    }),
    getFundNav: state => state.fundNav,
    getFundCurrentPeriod: state => state.fundCurrentPeriod,
    getFundCurrentUnitType: state => state.fundCurrentUnitType,
    getFundPeriod: state => state.fundPeriod,
    getFundFilter: state => state.fundFilter,
    getFundAmc: state => state.fundAmc,
    getFundCategories: state => state.fundCategories,
    getFundPagination: state => state.fundPagination,
    getFundFollowing: state => state.fundFollowing, 
}
  